import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useHttpClient } from '../hooks/useHttpClient';
import { useNotificacoes } from '../hooks/useNotificacoes';

import styles from './DetalharRateio.module.css';
import styles_global from '../css/global.module.css';
import styles_content from '../css/main-content.module.css';

function DetalharRateio() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { get } = useHttpClient();
    const { exibirErro } = useNotificacoes();

    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const idEmpresa = userData.empresa?.id || 0;

    const [usinas, setUsinas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);

    const [formData, setFormData] = useState({
        idUsina: '',
        idUsuario: '',
        unidadeNome: '',
        percentual: ''
    });

    // Formata número (string ou número) para "99,99 %"
    const formatarPercentual = (raw) => {
        const n = parseFloat(String(raw).replace(',', '.'));
        if (isNaN(n)) return '';
        const limitado = Math.min(n, 100);
        return limitado.toFixed(2).replace('.', ',') + ' %';
    };

    // 1. Carrega usinas e clientes (clientes da empresa, só para exibir na combo)
    useEffect(() => {
        if (!idEmpresa) return;

        (async () => {
            try {
                const filtrosU = new URLSearchParams({ idEmpresa, idTipoUsuario: 3 }).toString();
                const listaUsuarios = await get(`/hello-sol/usuarios/buscar?${filtrosU}`);
                setUsuarios(Array.isArray(listaUsuarios) ? listaUsuarios : (listaUsuarios.content ?? []));
            } catch {
                exibirErro('Erro ao buscar clientes.');
            }
            try {
                const filtrosS = new URLSearchParams({ idEmpresa }).toString();
                const listaUsinas = await get(`/hello-sol/usinas/buscar?${filtrosS}`);
                setUsinas(Array.isArray(listaUsinas) ? listaUsinas : (listaUsinas.content ?? []));
            } catch {
                exibirErro('Erro ao buscar usinas.');
            }
        })();
    }, [idEmpresa]);

    // 2. Carrega os dados do rateio
    useEffect(() => {
        if (!id) return;

        (async () => {
            try {
                const data = await get(`/hello-sol/rateios/${id}`);

                const idUsina = data?.usina?.id ?? '';
                const idCliente = data?.cliente?.id ?? ''; // <<< mudou
                const nomeUnidade = data?.unidadeConsumidora?.nomeUnidade ?? ''; // <<< mudou

                // Fallback: injeta cliente/usina na lista se não estiverem lá (combos desabilitadas, mas exibem correto)
                if (idCliente) {
                    setUsuarios((curr) => {
                        const has = curr.some((u) => String(u.id) === String(idCliente));
                        return has ? curr : [{ id: idCliente, nome: data?.cliente?.nome || 'Cliente' }, ...curr];
                    });
                }
                if (idUsina) {
                    setUsinas((curr) => {
                        const has = curr.some((u) => String(u.id) === String(idUsina));
                        return has ? curr : [{ id: idUsina, nome: data?.usina?.nome || 'Usina' }, ...curr];
                    });
                }

                setFormData({
                    idUsina,
                    idUsuario: idCliente,
                    unidadeNome: nomeUnidade,
                    percentual: formatarPercentual(data?.percentual)
                });
            } catch {
                exibirErro('Erro ao carregar detalhes do rateio.');
            }
        })();
    }, [id]);

    return (
        <div className={styles_global.container}>
            <h2>Detalhar Rateio</h2>
            <form>
                <div className={styles.linha2}>
                    {/* Usina */}
                    <div className={styles_content.formField}>
                        <label>Usina</label>
                        <select
                            value={formData.idUsina}
                            disabled
                            className={styles.campoUsina}
                        >
                            <option value="">Selecione</option>
                            {usinas.map((u) => (
                                <option key={u.id} value={u.id}>{u.nome}</option>
                            ))}
                        </select>
                    </div>

                    {/* Cliente */}
                    <div className={styles_content.formField}>
                        <label>Cliente</label>
                        <select
                            value={formData.idUsuario}
                            disabled
                            className={styles.campoCliente}
                        >
                            <option value="">Selecione</option>
                            {usuarios.map((u) => (
                                <option key={u.id} value={u.id}>{u.nome}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className={styles.linha2}>
                    <div className={styles_content.formField}>
                        <label>Unidade</label>
                        <input
                            type="text"
                            value={formData.unidadeNome}
                            className={styles.campoUnidade}
                            disabled
                        />
                    </div>
                    <div className={styles_content.formField}>
                        <label>Percentual do Rateio</label>
                        <input
                            type="text"
                            value={formData.percentual}
                            disabled
                            className={styles.campoPercentual}
                        />
                    </div>
                </div>

                <div className={styles_content.buttonGroup}>
                    <button type="button" onClick={() => navigate('/home/listar-rateio')}>
                        Voltar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default DetalharRateio;
